import React from 'react';
import styled from 'styled-components';

const StyledFeatureHighlight = styled.section`
  padding: 100px 20px;
  background: linear-gradient(180deg, #0f172a 0%, #1a1f3a 100%);
  
  .feature-grid {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 40px;
    margin-top: 60px;
  }
`;

const SectionTitle = styled.h2`
  font-size: clamp(2rem, 5vw, 3.5rem);
  font-weight: 700;
  color: #ffffff;
  text-align: center;
  margin-bottom: 1rem;
  
  background: linear-gradient(135deg, #ffffff 0%, #cbd5e1 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

const SectionSubtitle = styled.p`
  font-size: 1.2rem;
  color: #94a3b8;
  text-align: center;
  max-width: 700px;
  margin: 0 auto 60px;
  line-height: 1.6;
`;

interface FeatureHighlightProps {
  title: string;
  subtitle: string;
  children: React.ReactNode;
}

const FeatureHighlight: React.FC<FeatureHighlightProps> = ({ title, subtitle, children }) => {
  return (
    <StyledFeatureHighlight>
      <SectionTitle>{title}</SectionTitle>
      <SectionSubtitle>{subtitle}</SectionSubtitle>
      <div className="feature-grid">
        {children}
      </div>
    </StyledFeatureHighlight>
  );
};

export default FeatureHighlight;

